import { CLOSE_WIDGET } from '../constants/actionTypes'

export const closeWidget = () => ({
    type: CLOSE_WIDGET
})
